export const render = (...args: any) => {
  const { [0]: id, [1]: phase, [2]: actualDuraction, [6]: interactions } = args;

  console.log({ id, phase, actualDuraction, interactions })
}